export const CustomAlertIcons = {
    successCircle: `/assets/images/confirmDialog/successCircle.svg`,
    deleteFile: `/assets/images/confirmDialog/deleteFile.svg`,
    saveFile: `/assets/images/confirmDialog/saveFile.svg`,
    deleteConfirm: `/assets/images/confirmDialog/deleteConfirm.svg`
}